import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12.5V11.5C22 11.3674 21.9473 11.2402 21.8536 11.1464C21.7598 11.0527 21.6326 11 21.5 11H5.33L9.78 6.55997C9.82656 6.51435 9.86356 6.4599 9.88881 6.3998C9.91406 6.3397 9.92707 6.27516 9.92707 6.20997C9.92707 6.14478 9.91406 6.08025 9.88881 6.02015C9.86356 5.96005 9.82656 5.9056 9.78 5.85997L9.07 5.14997C9.02352 5.10311 8.96822 5.06591 8.90729 5.04053C8.84636 5.01514 8.78101 5.00208 8.715 5.00208C8.64899 5.00208 8.58364 5.01514 8.52271 5.04053C8.46178 5.06591 8.40648 5.10311 8.36 5.14997L2.22 11.28C2.08112 11.4217 2.0023 11.6116 2 11.81V12.19C2.00018 12.3888 2.07931 12.5795 2.22 12.72L8.36 18.85C8.40648 18.8968 8.46178 18.934 8.52271 18.9594C8.58364 18.9848 8.64899 18.9979 8.715 18.9979C8.78101 18.9979 8.84636 18.9848 8.90729 18.9594C8.96822 18.934 9.02352 18.8968 9.07 18.85L9.78 18.15C9.82686 18.1035 9.86406 18.0482 9.88945 17.9873C9.91483 17.9263 9.9279 17.861 9.9279 17.795C9.9279 17.729 9.91483 17.6636 9.88945 17.6027C9.86406 17.5418 9.82686 17.4865 9.78 17.44L5.33 13H21.5C21.6326 13 21.7598 12.9473 21.8536 12.8535C21.9473 12.7598 22 12.6326 22 12.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgBackOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgBackOutline;
